import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// All 4 locales are bundled eagerly — they're ~30KB each and needed
// immediately on startup to avoid a flash of the fallback language.
import de from './locales/de.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import ku from './locales/ku.json';

/** Languages that use right-to-left script */
const RTL_LANGUAGES = new Set(['ar', 'ku']);

/** Check if a language code is RTL (Kurdish + Arabic) */
export function isRtlLanguage(lang: string): boolean {
  return RTL_LANGUAGES.has(lang);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      ar: { translation: ar },
      ku: { translation: ku },
    },
    supportedLngs: ['de', 'en', 'ar', 'ku'],
    lng: (typeof globalThis.localStorage?.getItem === 'function'
      ? globalThis.localStorage.getItem('praxi-lang')
      : null) ?? 'ar',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'praxi-lang',
    },
  });

// Override i18n.dir() to include Kurdish as RTL
const originalDir = i18n.dir.bind(i18n);
i18n.dir = (lng?: string) => {
  const lang = lng || i18n.language;
  if (RTL_LANGUAGES.has(lang)) return 'rtl';
  return originalDir(lng);
};

export default i18n;
